import { useSelector } from "react-redux"

const useFormFields = () => {
    const { grades } = useSelector(state => state.testTaker)
    const { affiliations, groups } = useSelector(state => state.affiliation)

    const fields = [
        {
            name: "name",
            component: "input",
            placeholder: "שם ",
        },
        {
            name: 'group',
            component: "autoComplete",
            placeholder: "קבוצה",
            options: groups,
            className: "b-group",
            mandatory: true,
        },
        {
            name: 'affiliation',
            component: "autoComplete",
            placeholder: "יחידה",
            options: affiliations,
            mandatory: true,
        },
        {
            name: "grade",
            component: "autoComplete",
            placeholder: "שכבה",
            options: grades,
            className: "b-group",
            mandatory: true,
        }
    ]

    return fields
}

export default useFormFields